import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'mentions',
  templateUrl: './mentions.component.html',
  styleUrls: ['./mentions.component.scss']
})
export class MentionsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Mentions Légales');
    this.metaTagService.updateTag({
        name: 'description',
        content: 'Mentions Légales - Centre de Formation du Languedoc.'
    });

  }

}
